import { IconProps } from './types';

export default function Video({ className, strokeWidth }: IconProps) {
    return (
        <svg
            fill="none"
            height="24"
            viewBox="0 0 24 24"
            width="24"
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden
            role="img"
        >
            <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={strokeWidth}
                d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z"
            />
            <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={strokeWidth}
                d="M8.25 12c0 3.512 1.25 6.649 3.214 8.765a.73.73 0 0 0 1.072 0C14.5 18.649 15.75 15.512 15.75 12c0-3.512-1.25-6.649-3.214-8.765a.73.73 0 0 0-1.072 0C9.5 5.351 8.25 8.488 8.25 12ZM3 12h18"
            />
        </svg>
    );
}
